import { useTheme } from "@hooks/useTheme";
import { t } from "i18next";

const CustomToggle = ({
  title,
  value,
  onChange,
  disabled = false,
  className = "",
  "data-testid": dataTestId,
}) => {
  const { colors } = useTheme();
  const isOn = value === "Y" || value === "Yes";
  const testId = (suffix) => (dataTestId ? `${dataTestId}-${suffix}` : undefined);

  const handleToggle = () => {
    if (!disabled) {
      const newValue = isOn ? "N" : "Y";
      onChange(newValue);
    }
  };

  return (
    <div
      className={`flex flex-row justify-between items-center space-y-0 space-x-14 ${className}`}
      data-testid={dataTestId}
    >
      {title && (
        <span
          className={`text-sm font-semibold ${colors.textSecondary} whitespace-nowrap`}
          data-testid={testId("title")}
        >
          {title}
        </span>
      )}

      <div className="flex items-center space-x-2" data-testid={testId("control")}>
        <button
          type="button"
          data-testid={testId("switch")}
          onClick={handleToggle}
          disabled={disabled}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors
            ${isOn ? colors.bgToggleSwitchActive : colors.bgToggleSwitchInactive}
            ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full ${colors.toggleThumbBackground} transition-transform
              ${isOn ? "translate-x-6" : "translate-x-1"}
            `}
            data-testid={testId("thumb")}
          />
        </button>
        <span className={`text-sm font-medium min-w-[2rem] ${colors.textSubTitle}`} data-testid={testId("label")}>
          {isOn ? t("common.yes") : t("common.no")}
        </span>
      </div>
    </div>
  );
};

export default CustomToggle;
